export default __webpack_public_path__ + "static/media/burninghex.50aef5a8.png";